// Provide `regeneratorRuntime` for any code babel compiled to regenerator
// (async/await / generators). Must precede all other imports so the global
// exists before transpiled module bodies evaluate.
import 'regenerator-runtime/runtime';

// Make React Native's Alert.alert actually work on web (RNW ships a no-op, so
// confirm dialogs like TimeClock's clock-in never fire). Side-effect import.
import '@/web-stubs/alert-polyfill';

// Minimal `process` polyfill — react-native-reanimated's PlatformChecker
// (and a few other RN packages) reference `process.env` at runtime, which
// webpack 5 no longer auto-polyfills for the browser. Substituted at
// build time by webpack's DefinePlugin for `process.env.NODE_ENV`, but
// reanimated does other lookups too.
if (typeof window !== 'undefined' && !window.process) {
  window.process = { env: { NODE_ENV: 'development' } };
}

import { AppRegistry } from 'react-native';
import App from './App.web';

AppRegistry.registerComponent('SGAMobile', () => App);

AppRegistry.runApplication('SGAMobile', {
  initialProps: {},
  rootTag: document.getElementById('root'),
});
